export const topScribeApps: { [host: string]: string } = {
  'docs.google.com': 'Google Docs',
  'mail.google.com': 'Gmail',
  'accounts.google.com': 'Google Accounts',
  'drive.google.com': 'Google Drive',
  'www.google.com': 'Google',
  'www.youtube.com': 'YouTube',
  'outlook.office.com': 'Outlook',
  'app.hubspot.com': 'HubSpot',
  'calendar.google.com': 'Google Calendar',
  'www.canva.com': 'Canva',
  'www.facebook.com': 'Facebook',
  'www.linkedin.com': 'LinkedIn',
  'app.qbo.intuit.com': 'QuickBooks',
  'chat.openai.com': 'OpenAI Chat',
  'admin.shopify.com': 'Shopify',
  'www.bing.com': 'Bing',
  'web.whatsapp.com': 'WhatsApp',
  'business.facebook.com': 'Facebook Business',
  'meet.google.com': 'Google Meet',
  'www.notion.so': 'Notion',
  'go.xero.com': 'Xero',
  'teams.microsoft.com': 'Microsoft Teams',
  'www.office.com': 'Microsoft Office',
  'contacts.google.com': 'Google Contacts',
  'app.clickup.com': 'ClickUp',
  'workforcenow.adp.com': 'ADP Workforce Now',
  'airtable.com': 'Airtable',
  'app.asana.com': 'Asana',
  'outlook.office365.com': 'Outlook 365',
  'app.powerbi.com': 'Power BI',
  'businesscentral.dynamics.com': 'Dynamics 365',
  'chat.google.com': 'Google Chat',
  'app.smartsheet.com': 'Smartsheet',
  'portal.azure.com': 'Azure Portal',
  'github.com': 'GitHub',
  'ads.google.com': 'Google Ads',
  'www.instagram.com': 'Instagram',
  'app.slack.com': 'Slack',
  'www.amazon.com': 'Amazon',
  'analytics.google.com': 'Google Analytics',
  'www.figma.com': 'Figma',
  'zoom.us': 'Zoom',
  'www.zoom.com': 'Zoom',
  'www.myworkday.com': 'Workday',
  'www.loom.com': 'Loom',
  'trello.com': 'Trello',
  'myaccount.google.com': 'Google Account',
  'admin.microsoft.com': 'Microsoft Admin',
  'forms.office.com': 'Microsoft Forms',
  'impl.workday.com': 'Workday',
  'apps.powerapps.com': 'Power Apps',
  'chatgpt.com': 'ChatGPT',
  'www.microsoft365.com': 'Microsoft 365',
  'www.paycomonline.net': 'Paycom',
  'twitter.com': 'Twitter',
  'dashboard.stripe.com': 'Stripe',
  'admin.google.com': 'Google Admin',
  'adsmanager.facebook.com': 'Facebook Ads Manager',
  'sites.google.com': 'Google Sites',
  'login.paylocity.com': 'Paylocity',
  'classroom.google.com': 'Google Classroom',
  'sellercentral.amazon.com': 'Amazon Seller Central',
  'calendly.com': 'Calendly',
  'crm.zoho.com': 'Zoho CRM',
  'www.microsoft.com': 'Microsoft',
  'discord.com': 'Discord',
  'www.dropbox.com': 'Dropbox',
  'app.gohighlevel.com': 'HighLevel',
  'outlook.live.com': 'Outlook',
  'studio.youtube.com': 'YouTube Studio',
  'manage.wix.com': 'Wix',
  'dev.azure.com': 'Azure DevOps',
  'accounts.intuit.com': 'Intuit Accounts',
  'zapier.com': 'Zapier',
  'employers.indeed.com': 'Indeed',
  'cdn.walkme.com': 'WalkMe',
  'onedrive.live.com': 'OneDrive',
  'tagmanager.google.com': 'Google Tag Manager',
  'login.salesforce.com': 'Salesforce',
  'online.adp.com': 'ADP Online',
  'myapps.classlink.com': 'ClassLink',
  'go.servicetitan.com': 'ServiceTitan',
  'login.live.com': 'Microsoft Account',
  'openai.com': 'OpenAI',
  'app.gusto.com': 'Gusto',
  'qbo.intuit.com': 'QuickBooks Online',
  'clever.com': 'Clever',
  'apps.docusign.com': 'DocuSign',
  'webflow.com': 'Webflow',
  'reporting.xero.com': 'Xero Reporting',
  'en.wikipedia.org': 'Wikipedia',
  'lookerstudio.google.com': 'Looker',
  'www.paypal.com': 'PayPal',
  'app.bullhornstaffing.com': 'Bullhorn',
  'subscriptions.qas.invisalign.com': 'Invisalign',
  'substrate.office.com': 'Microsoft Substrate',
  'preview.stpis.com': 'STPIS',
  'plugin.intuitcdn.net': 'Intuit CDN',
  'squareup.com': 'Square',
  'app.docusign.com': 'DocuSign',
  'login.xero.com': 'Xero',
  'mail.yahoo.com': 'Yahoo Mail',
  'www.concursolutions.com': 'Concur',
  'app.paylocity.com': 'Paylocity',
  'www.wrike.com': 'Wrike',
  'us2.concursolutions.com': 'Concur',
  'vimeo.com': 'Vimeo',
  'support.google.com': 'Google Support',
  'business.google.com': 'Google Business',
  'tasks.office.com': 'Microsoft Tasks',
  'www.klaviyo.com': 'Klaviyo',
  'athenanet.athenahealth.com': 'AthenaNet',
  'www.fedex.com': 'FedEx',
  'platform.openai.com': 'OpenAI Platform',
  'www.mailinator.com': 'Mailinator',
  'account.activedirectory.windowsazure.com': 'Azure Active Directory',
  'hcm.paycor.com': 'Paycor',
  'mysignins.microsoft.com': 'Microsoft Sign-ins',
  'account.docusign.com': 'DocuSign',
  'www.msn.com': 'MSN',
  'editor.wix.com': 'Wix Editor',
  'us02.procore.com': 'Procore',
  'myapps.paychex.com': 'Paychex',
  'translate.google.com': 'Google Translate',
  'make.powerautomate.com': 'Power Automate',
  'make.powerapps.com': 'Power Apps',
  'clients.mindbodyonline.com': 'Mindbody',
  'search.yahoo.com': 'Yahoo Search',
  'www.jotform.com': 'JotForm',
  'accounts.youtube.com': 'YouTube Accounts',
  'www.reddit.com': 'Reddit',
  'support.microsoft.com': 'Microsoft Support',
  'app.intercom.com': 'Intercom',
  'www.tiktok.com': 'TikTok',
  'learn.microsoft.com': 'Microsoft Learn',
  'app.clio.com': 'Clio',
  'miro.com': 'Miro',
  'host.nxt.blackbaud.com': 'Blackbaud',
  'myaccount.microsoft.com': 'Microsoft Account',
  'app.procore.com': 'Procore',
  'app.pandadoc.com': 'PandaDoc',
  'platform.twitter.com': 'Twitter',
  'access.paylocity.com': 'Paylocity',
  'members.centralreach.com': 'CentralReach',
  'play.google.com': 'Google Play',
  'acrobat.adobe.com': 'Adobe Acrobat',
  '3.basecamp.com': 'Basecamp',
  'na.myconnectwise.net': 'ConnectWise',
  'www.appsheet.com': 'AppSheet',
  'shared.officeapps.live.com': 'Microsoft Office',
  'auth.services.adobe.com': 'Adobe',
  'www.toasttab.com': 'Toast',
  'accounts.shopify.com': 'Shopify',
  'player.vimeo.com': 'Vimeo',
  'open.spotify.com': 'Spotify',
  'www.ups.com': 'UPS',
  'app.kajabi.com': 'Kajabi',
  'app.apollo.io': 'Apollo',
  'admin.exchange.microsoft.com': 'Microsoft Exchange',
  'www.adobe.com': 'Adobe',
  'app.rippling.com': 'Rippling',
  'service.force.com': 'Salesforce',
  'lastpass.com': 'LastPass',
  'buildertrend.net': 'BuilderTrend',
  'www.coursera.org': 'Coursera',
  'partner.microsoft.com': 'Microsoft Partner',
  'webtime2.paylocity.com': 'Paylocity',
  'workspace.google.com': 'Google Workspace',
  'www.googletagmanager.com': 'Google Tag Manager',
  'one.zoho.com': 'Zoho',
  'www.ilovepdf.com': 'I Love PDF',
  'app.grammarly.com': 'Grammarly',
  'payroll.xero.com': 'Xero Payroll',
  'www.netflix.com': 'Netflix',
  'quillbot.com': 'Quillbot',
  'entra.microsoft.com': 'Microsoft Entra',
  'www.indeed.com': 'Indeed',
  'bard.google.com': 'Google Bard',
  'intune.microsoft.com': 'Microsoft Intune',
  'www.employeenavigator.com': 'Employee Navigator',
  'tsheets.intuit.com': 'TSheets',
  'www.zillow.com': 'Zillow',
  'app.zoominfo.com': 'ZoomInfo',
  'remotedesktop.google.com': 'Google Remote Desktop',
  'myapps.microsoft.com': 'Microsoft Apps',
  'www.deepl.com': 'DeepL',
  'quickbooks.intuit.com': 'QuickBooks',
  'hello.dubsado.com': 'Dubsado',
  'myapplications.microsoft.com': 'Microsoft Apps',
  'headway-widget.net': 'Headway',
  'lucid.app': 'Lucid',
  'content.googleapis.com': 'Google Content',
  'myinvisalign-web-qas-us.herokuapp.com': 'Invisalign',
  'service.ringcentral.com': 'RingCentral',
  'app.salesloft.com': 'SalesLoft',
  'id.atlassian.com': 'Atlassian',
  'app.frontapp.com': 'Front',
  'secure.simplepractice.com': 'SimplePractice',
  'cdn.comparably.com': 'Comparably',
  'app.constantcontact.com': 'Constant Contact',
  'www.google.co.uk': 'Google UK',
  'www.irs.gov': 'IRS',
  'keep.google.com': 'Google Keep',
  'dash.cloudflare.com': 'Cloudflare',
  'business.bing.com': 'Bing Business',
  'vip.qas.invisalign.com': 'Invisalign',
  'duckduckgo.com': 'DuckDuckGo',
  'pinnaclesit-fut.leza.co.za': 'Pinnacle',
  'script.google.com': 'Google Script',
  'owl.officeapps.live.com': 'Microsoft Office',
  'account.godaddy.com': 'GoDaddy',
  'www.etsy.com': 'Etsy',
  'groups.google.com': 'Google Groups',
  'googleads.g.doubleclick.net': 'Google Ads',
  'www.semrush.com': 'SEMrush',
  'aws.amazon.com': 'Amazon Web Services',
  'support.prismhr.com': 'PrismHR',
  'www.pinterest.com': 'Pinterest',
  'staging3.traf.mb.ca': 'Traf',
  'oauth.online.office.com': 'Microsoft Office',
  'www.speedtest.net': 'Speedtest',
  'app.hibob.com': 'Hibob',
  'js.driftt.com': 'Drift',
  'gamma.app': 'Gamma',
  'medium.com': 'Medium',
  'code.gist.build': 'Gist',
  'app.luxurypresence.com': 'Luxury Presence',
  'www.udemy.com': 'Udemy',
  'account.squarespace.com': 'Squarespace',
  'security.microsoft.com': 'Microsoft Security',
  'podio.com': 'Podio',
  'app.dext.com': 'Dext',
  'www.expensify.com': 'Expensify',
  'app.clockify.me': 'Clockify',
  'admin.streamlinevrs.com': 'StreamlineVRS',
  'www.eventbrite.com': 'Eventbrite',
  'www.zoho.com': 'Zoho',
  'www.roblox.com': 'Roblox',
  'login.mailchimp.com': 'Mailchimp',
  'www.upwork.com': 'Upwork',
  'photos.google.com': 'Google Photos',
  'www-p02.intacct.com': 'Intacct',
  'app02.us.bill.com': 'Bill.com',
  'login.i-ready.com': 'i-Ready',
  'books.zoho.com': 'Zoho Books',
  'insight.adsrvr.org': 'Ad Server',
  'apps.availity.com': 'Availity',
  'app.contentful.com': 'Contentful',
  'secure.helpscout.net': 'Help Scout',
  'web.outreach.io': 'Outreach',
  'www.surveymonkey.com': 'SurveyMonkey',
  'www.grammarly.com': 'Grammarly',
  'sso.godaddy.com': 'GoDaddy',
  'scratch.mit.edu': 'Scratch',
  'www.godaddy.com': 'GoDaddy',
  'coda.io': 'Coda',
  'system.netsuite.com': 'NetSuite',
  'login.qas.aligntech.com': 'AlignTech',
  'www.airbnb.com': 'Airbnb',
  'www.bbc.co.uk': 'BBC',
  'secure5.saashr.com': 'SaaSHR',
  'app.getbeamer.com': 'Get Beamer',
  'stackoverflow.com': 'Stack Overflow',
  'signin.aws.amazon.com': 'Amazon Sign-in',
  'www.yahoo.com': 'Yahoo',
  'inventory.dearsystems.com': 'Dear Systems Inventory',
  'web.telegram.org': 'Telegram',
  'rise.articulate.com': 'Articulate Rise',
  'www.shopify.com': 'Shopify',
  'emea.subscriptions.qas.invisalign.com': 'Invisalign',
  'dcc.godaddy.com': 'GoDaddy',
  'secure.paycor.com': 'Paycor',
};
